import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CommsService } from '../comms/comms.service';
import { DataService } from '../data/data.service';
import { NoteService } from '../note/note.service';
import { ConfigService } from '../config/config.service';
import { AccountService } from '../account/account.service';
import { DisplayService } from '../display/display.service';
import { TabService } from '../tab/tab.service';
import { UserService } from '../user/user.service';
import { DataTableService } from '../dataTable/dataTable.service';
import _ from 'lodash';
import { of } from 'rxjs';
import { TimesheetLocalizationService } from '../timesheet-localization/timesheet-localization.service';
// import { setColumnDefaults } from '@swimlane/ngx-datatable/release/utils';

@Injectable()
export class TimesheetService {

	objString = 'Timesheets';
	objRoot = 'timesheet';
	listRoot = 'timesheets';
	dataObj = 'timesheet';
	pendingDataObj = 'timesheet-pending';
	escalatedDataObj = 'timesheet-escalated';
	errorDataObj = 'timesheeterror';
	successDataObj = 'timesheetsuccess';
	trimmedSheet = false;
	rowsUnique = true;
	rowsAccess = true;
	rowsBlank = true;
	rowsILCValid = true;
	rowsZeroValid = true;
	correctRowsZeroValid = true;
	rowsUniqueness = [];
	rowsAccessibility = [];
	rowsBlankness = [];
	rowsILCValidity = [];
	rowsZeroValidity = [];
	correctRowsZeroValidity = [];
	rowsCorrectUnique = true;
	rowsCorrectAccess = true;
	rowsCorrectILCValid = true;
	rowsCorrectUniqueness = [];
	rowsCorrectAccessibility = [];
	rowsCorrectILCValidity = [];
	// sufficientfunds = true;
	currency: string;
	noteMessage = '';
	moreThanDailyAllowedHours = false;
	totalNonbillableHours = 0;
	submitIdentity = '';
	awaitingContractor = false;
	hoursAllowed = true;

	showErrorTimesheets = false;
	showSuccessTimesheets = false;

	contractorPO = '';
	contractorId = '';
	contractorSupplierId = '';
	ilcSerial = '';

	invoiceData = {};

	showAccountsResults = -1;

	loading = false;
	nonBillableCodes;

	emptyAccount = {
		accountid: '',
		activitycode: '',
		workitemdescription: '',
		billcode: '',
		groupid: '',
		workitemid: ''
	};

	tabsData = {
		tabs: [],
		listTabs: [
			{
				prop: 'save',
				name: 'Saved',
				active: false,
				persona: ['contractor'],
				notPersona: [''],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'escalations',
				name: 'Escalated',
				active: false,
				persona: ['all'],
				notPersona: ['contractor'],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'pending',
				name: 'Pending',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'rejected',
				name: 'Rejected',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		contractorListTabs: [
			{
				prop: 'rejected',
				name: 'Rejected',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'contractor',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'contractor',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		invoiceListTabs: [
			{
				prop: 'all',
				name: 'All',
				active: true,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'invoice',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		bcinvoiceListTabs: [
			{
				prop: 'all',
				name: 'All',
				active: true,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'bcinvoice',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		poListTabs: [
			{
				prop: 'all',
				name: 'All',
				active: true,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
	};

	pathToTimesheet = 'timesheet';

	trimmedSheetReasons = {
		contractorStardEndDate: 'This timesheet is not showing a full week. Some days are oustide the contractor\'s start or end date.',
		ibmToKyndrylCutover: 'This timesheet is not showing a full week. Remaining days should be logged against your timesheet on your Kyndryl PO.'
	};

	trimmedSheetReason: string;

	rowsPerPage = 15;
	
	// a list of countries that a user manages, to populate the country list on the timesheet bulk page
	// this object has properties "prop" and "name", where the prop is the countryCode string. This is to match with the Action List component
	userManagedCountries;
	// the country object (same props as userManagedCountries) selected to view (by the user or automatically if there's only one)
	userManagedCountrySelection;

	contractorILCUpdated = false;
	originalILCFromContractor: boolean;

	constructor(
		private router: Router,
		private commsService: CommsService,
		private dataService: DataService,
		private noteService: NoteService,
		private configService: ConfigService,
		private accountService: AccountService,
		private displayService: DisplayService,
		private tabService: TabService,
		private userService: UserService,
		private dataTableService: DataTableService,
		private timesheetLocalizationService: TimesheetLocalizationService
	) {
		this.rowsPerPage = this.configService.pageSize;
	}

	isSaved() {
		return this.dataService.timesheetDetails[this.configService.timeentryProp][0]['status'] === this.configService.timesheetSaveStatus ? true : false;
	}

	// TABBING METHODS

	getActiveTab(tabsData): any {
		let activeTab = {};
		tabsData.forEach(function (d, i) {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	tabClick(event, tabProp, tabsData, type) {
		console.log('TAB CLICK', event, tabProp, tabsData);
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
							window.history.replaceState({}, '', '/timesheets/' + tabProp);
							// need clean up sort
							if (d['sortParam']) {
								d['sortParam'] = '';
								d['sortDir'] = '';
							}
							self.loadTimesheetsForTab(d);
							break;
						case 'contractor':
							self.loadContractorTimesheetsForTab(d);
							break;
					}
				}
			}
		});
	}

	selectDefaultTab(tabsData) {
		const self = this;
		tabsData.forEach(function (d, i) {
			tabsData[i].active = false;
			tabsData[i].cached = false;
		});
		let foundDefault = false;
		let defaultIndex = -1;
		tabsData.forEach(function (d, i) {
			console.log('CHECK TAB FOR DEFAULT', d, self.tabService.showTab(d.persona, d.notPersona));
			if (self.tabService.showTab(d.persona, d.notPersona) && !foundDefault) {
				foundDefault = true;
				defaultIndex = i;
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
							self.loadTimesheetsForTab(d);
							break;
						case 'contractor':
							self.loadContractorTimesheetsForTab(d);
							break;
						case 'invoice':
							self.loadInvoiceTimesheetsForTab(d);
							break;
						case 'bcinvoice':
							self.loadBCInvoiceTimesheetsForTab(d);
							break;
					}
				}
			}
		});
		tabsData[defaultIndex].active = true;
		console.log('SELECTED DEFAULT TAB', tabsData);
	}

	selectActiveTab(tabsData, tabProp) {
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
							self.loadTimesheetsForTab(d);
							break;
						case 'contractor':
							self.loadContractorTimesheetsForTab(d);
							break;
					}
				}
			}
		});
	}

	showTabSearch(tabsData) {
		this.getActiveTab(tabsData)['searching'] = !this.getActiveTab(tabsData)['searching'];
	}

	checkTabs(tabsData) {
		// expected method, no logic needed for po page tabs
		// see same method in contractorService for example of use
	}

	loadAllforTab(tab) {
		if (tab.listTab) {
			switch (tab.type) {
				case 'standard':
					this.downloadTimesheetsForTab(tab);
					break;
				case 'contractor':
					this.loadContractorTimesheetsForTab(tab, true);
					break;
			}
		}
	}

	downloadTimesheetsForTab(tab) {
		const self = this;
		const dataObject = _.cloneDeep(tab);
		dataObject[this.configService.countryCodeProp] = this.userManagedCountrySelection.prop;
		this.commsService.downloadAllTimesheets(dataObject).subscribe((res) => {
			// console.log('DOWNLOAD ALL TIMESHEETS RES: ', res);
			// have to hard code for the quick push to production
			self.commsService.saveToCSV(dataObject.filename, res);
		}, (err) => {
			self.commsService.handleAPIError('Download All Timesheets', err);
		});
	}

	loadTimesheetsForTab(tab, loadAll = false) {
		console.log('LOAD TIMESHEETS FOR TAB', tab);
		this.loadTimesheets(tab, loadAll);
	}

	loadContractorTimesheetsForTab(tab, loadAll = false) {
		console.log('LOAD CONTRACTOR TIMESHEETS FOR TAB', tab);
		this.loadContractorTimesheets(tab, loadAll);
	}

	loadInvoiceTimesheetsForTab(tab) {
		console.log('LOAD INVOICE TIMESHEETS FOR TAB', tab);

		this.displayService.startLoading();
		// either retrieve nonBillableCodes or use existing
		(this.nonBillableCodes ? of(null) : this.commsService.getNonBillableCodes()).subscribe((res) => {
			this.nonBillableCodes = (this.nonBillableCodes ? this.nonBillableCodes : this.commsService.getSuccessData(res).ilccodes);
			const timesheets = this.retrieveInvoiceTimesheets(this.dataService.invoiceDetails['contractortimesheets'], this.nonBillableCodes);
			this._updatePagination(timesheets, tab);
			this.displayService.endLoading();
		});
	}

	_updatePagination(timesheets, tab) {
		const dataRef = this.dataObj + '-' + tab.prop + '-' + tab.type;
		const bIdx = tab.page * this.configService.pageSize;
		const eIdx = (tab.page + 1) * this.configService.pageSize >= timesheets.length ? timesheets.length : (tab.page + 1) * this.configService.pageSize;
		this.dataService.updatePageData(dataRef, tab, timesheets.slice(bIdx, eIdx));
		this.dataService.updateDataCount(dataRef, timesheets.length);
	}

	loadBCInvoiceTimesheetsForTab(tab) {
		console.log('LOAD INVOICE TIMESHEETS FOR TAB', tab);

		this.displayService.startLoading();
		// either retrieve nonBillableCodes or use existing
		(this.nonBillableCodes ? of(null) : this.commsService.getNonBillableCodes()).subscribe((res) => {
			this.nonBillableCodes = (this.nonBillableCodes ? this.nonBillableCodes : this.commsService.getSuccessData(res).ilccodes);
			const timesheets = this.retrieveInvoiceTimesheets(this.dataService.bcinvoiceDetails['invoicetimesheets'], this.nonBillableCodes);
			this._updatePagination(timesheets, tab);
			this.displayService.endLoading();
		});
	}

	// UI INTERACTIONS
	openTimesheet(poNumber, contractorId, supcontId, supplierId, date, dates?) {
		console.log('OPEN TIMESHEET', poNumber, contractorId, supcontId, supplierId, date);
		this.dataService.clearTimesheetData();
		this.dataService.reasoncode = null;
		let navigateToTimesheet = true;
		if (dates !== undefined) {
			const queryDate = new Date(date);
			const queryTime = queryDate.getTime();
			const contractorStartDate = new Date(dates[this.configService.contractorStartProp]);
			const contractorStartTime = contractorStartDate.getTime();
			const contractorEndDate = this.dataService.applyGracePeriod(new Date(dates[this.configService.contractorEndProp]));

			const contractorEndTime = contractorEndDate.getTime();
			if (queryTime > contractorEndTime || queryTime < contractorStartTime) {
				navigateToTimesheet = false;
			}
		}
		if (navigateToTimesheet) {
			if (supcontId) {
				this.router.navigateByUrl(this.objRoot + '/' + poNumber + '/' + contractorId + '/' + supcontId + '/' + supplierId + '/' + date);
			} else {
				this.router.navigateByUrl(this.objRoot + '/' + poNumber + '/' + contractorId + '/' + supplierId + '/' + date);
			}
		} else {
			this.noteService.displayWarning('Please select a date within the contractor start & end dates.');
		}
	}

	tableClick(event) {
		console.log('TABLE CLICK: ', event);
		const clickedRow = event.row;
		const poNumber = clickedRow[this.configService.poNumberProp];
		if (this.dataService.userKeys) {
			const poObj = this.dataService.userKeys[poNumber];
			this.dataService.selectedPO = {
				name: poNumber,
				prop: poNumber,
				tooltip: poObj.actualstartdate + ' - ' + poObj.actualenddate
			};
		}

		const contractorId = clickedRow[this.configService.contractorIdProp];
		const supcontId = clickedRow[this.configService.supcontIdProp];
		const supplierId = clickedRow[this.configService.supplierIdProp];
		const date = clickedRow[this.configService.startDateProp];
		this.openTimesheet(poNumber, contractorId, supcontId, supplierId, date);
	}

	tableSelect(event) {
		console.log('TIMESHEET TABLE SELECT: ', event);
		// for some reason this.dataService.selectedTableRows is not updated by select all
		this.dataService.selectedTableRows = event.selected;
	}

	tableRefresh(event) {
		console.log('TIMESHEET TABLE REFRESH: ', event);
		this.rowsPerPage = event.data.rowsPerPage;
		const tabs = this.tabsData.listTabs;
		tabs.map(tab => {
			tab['pageSize'] = this.rowsPerPage;
		});
		this.loadTimesheetsForTab(this.getActiveTab(tabs));
	}

	tablePage(event, tabs?) {
		if (!tabs) {
			tabs = this.tabsData.listTabs;
		}
		console.log('TIMESHEET TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(tabs);
		this.getActiveTab(tabs)['page'] = event.offset;
		this.loadTimesheetsForTab(activeTab);
	}

	invoiceTimesheetsTablePage(event) {
		console.log('INVOICE TIMESHEET TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.invoiceListTabs);
		activeTab['page'] = event.offset;
		this.loadInvoiceTimesheetsForTab(activeTab);
	}

	bcinvoiceTimesheetsTablePage(event) {
		console.log('BC INVOICE TIMESHEET TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.bcinvoiceListTabs);
		activeTab['page'] = event.offset;
		this.loadInvoiceTimesheetsForTab(activeTab);
	}

	tableSort(event) {
		this.dataTableService.tableSort(event, this.getActiveTab(this.tabsData.listTabs), (tab) => this.loadTimesheetsForTab(tab));
	}

	tableSearch(event) {
		console.log('TIMESHEET TABLE SEARCH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadTimesheetsForTab(activeTab);
	}

	hideAccountSearch() {
		this.showAccountsResults = -1;
	}

	addRow(isCorrection, account = this.emptyAccount) {
		const self = this;
		const dataRows = isCorrection ? this.dataService.timesheetCorrectRows : this.dataService.timesheetRows;
		const newRows = _.cloneDeep(dataRows);
		const newRow = _.cloneDeep(newRows[newRows.length - 1]);
		newRow.forEach(function (d, i) {
			d.value = null;
			d.account = _.cloneDeep(account);
		});
		if (isCorrection) {
			newRow['newRow'] = true;
		}
		console.log('NEW TIMESHEET ROW', newRow);
		newRows.push(newRow);
		this.dataService.updateTimesheetRows(newRows, isCorrection);
		this.calculateTotal();
	}

	deleteRow(rowIndex, isCorrection) {
		const dataRows = isCorrection ? this.dataService.timesheetCorrectRows : this.dataService.timesheetRows;
		const newRows = _.cloneDeep(dataRows);
		newRows.splice(rowIndex, 1);
		this.dataService.updateTimesheetRows(newRows, isCorrection);
		this.calculateTotal();
		this.checkHourRules();
	}


	/**
	 * check if the row can be delected
	 */
	canDeleteRow(isCorrection, timesheetStatus, index) {
		// console.log('CAN DELETE ROW', isCorrection, timesheetStatus, index);
		let canDeleteRow = false;

		if (this.configService.canDo(this.configService.getDataObj(this.configService.timesheetDataObj).fields, this.configService.timeentryProp, 'edit')) {
			const normalRows = this.dataService.timesheetRows;
			const correctRows = this.dataService.timesheetCorrectRows;

			if (!isCorrection) {
				if (normalRows.length > 1 && timesheetStatus !== this.configService.timesheetSubmitStatus) {
					canDeleteRow = true;
				}
			} else {
				if (index > normalRows.length - 1) {
					canDeleteRow = true;
				}
			}
		}

		return canDeleteRow;
	}

	recUpload(type, data) {
		console.log('REC UPLOAD', type, data.length, this.dataService.timesheetDetails
		[this.configService.timesheetIDProp]);
		const entityId = this.dataService.timesheetDetails[this.configService.timesheetIDProp];
		const supplierid = this.dataService.timesheetDetails[this.configService.supplierIdProp];
		const formData = new FormData();
		for (let x = 0; x < data.length; x++) {
			formData.append('file-' + x, data[x]);
		}
		formData.append('entityid', entityId);
		formData.append('supplierid', supplierid);
		formData.append('type', type);
		console.log('FORM DATA', formData.get('file'), formData.get('entityid'), formData.get('type'));
		this.sendExpenseUpload(formData);
	}

	// AUTOMATED PROCESSES

	checkSubmitIdentity() {
		const timesheet = this.dataService.timesheetDetails;
		try {
			const approvalObj = timesheet[this.configService.timeentryProp][0][this.configService.timesheetApprovalObjProp];
			const approvalField = approvalObj[this.configService.timesheetSAMApprovalFieldProp];
			if (approvalField === this.configService.timesheetSAMSubmitStatus) {
				this.submitIdentity = 'SAM';
			} else {
				this.submitIdentity = 'contractor';
			}
		} catch (e) {
			console.log('COULD NOT GET SUBMIT IDENTITY FOR TIMESHEET', timesheet, e);
		}
	}

	checkValidRows() {
		this.checkUniqueRows();
		this.checkBlankRows();
		// this.checkAccessRows();
		this.checkILCValidRows();
		// need validate special TS row with zero hour configuration
		this.checkZeroRows();
		this.calculateTotal();
	}

	checkBlankRows() {
		this.rowsBlank = false;
		this.rowsBlankness = [];

		const self = this;
		this.dataService.timesheetRows.forEach(function (d, i) {
			// console.log('CHECK BLANK ROW', d);
			if (d[0].account.accountid !== undefined && d[0].account.accountid !== '') {
				self.rowsBlankness[i] = false;
			} else {
				self.rowsBlankness[i] = true;
				self.rowsBlank = true;
			}
		});
		// console.log('ROWS BLANKNESS', this.rowsBlankness, this.rowsBlank);
	}

	checkUniqueRows() {
		this.rowsUnique = true;
		this.rowsUniqueness = [];

		const self = this;
		this.dataService.timesheetRows.forEach(function (d, i) {
			// console.log('CHECK UNIQUE ROW', d);
			self.rowsUniqueness[i] = true;
			if (d[0].account.accountid !== undefined) {
				// create a unique signature for the row based on the account selections
				let rowSig = d[0].account.accountid + d[0].account.workitemid;
				if (d[0].account.workitemdescription) {
					rowSig += d[0].account.workitemdescription;
				}
				rowSig += d[0].account.activitycode + d[0].account.billcode + d[0].type;
				if (d[0].account.activitydescription) {
					rowSig += d[0].account.activitydescription;
				}
				// check this row against all other rows
				self.dataService.timesheetRows.forEach(function (dd, ii) {
					let rowSigCheck = dd[0].account.accountid + dd[0].account.workitemid;
					if (dd[0].account.workitemdescription) {
						rowSigCheck += dd[0].account.workitemdescription;
					}
					rowSigCheck += dd[0].account.activitycode + dd[0].account.billcode + dd[0].type;
					if (dd[0].account.activitydescription) {
						rowSigCheck += dd[0].account.activitydescription;
					}
					// compare signatures but don't check against itself
					if (i !== ii && rowSig === rowSigCheck) {
						// if sigs match all rows are not unique
						self.rowsUnique = false;
						self.rowsUniqueness[i] = false;
						self.rowsUniqueness[ii] = false;
					}
				});
			}
		});
		console.log('ROWS UNIQUENESS', this.rowsUniqueness);
	}

	checkILCValidRows() {
		this.rowsILCValid = true;
		this.rowsILCValidity = [];

		const self = this;
		this.dataService.timesheetRows.forEach(function (d, i) {
			console.log('CHECK ILC VALID ROW', d);
			self.rowsILCValidity[i] = true;
			const canEditCustomType = self.configService.canEditCustomTimesheetLineItem(d[0].type);
			const timesheetStatus = self.dataService.getTimesheetStatus();
			const shouldCheck = timesheetStatus === self.configService.timesheetSaveStatus;
			const canEdit = self.configService.canDo(self.configService.getDataObj(self.configService.timesheetDataObj).fields, self.configService.timeentryProp, 'edit');

			if (shouldCheck && canEdit && !canEditCustomType) {
				if (!d[0].account.ilcValid) {
					self.rowsILCValid = false;
					self.rowsILCValidity[i] = false;
				}
			}
		});
		console.log('ROWS VALIDITY', this.rowsILCValidity);
	}
	// for zero hour configuration workitems (returned from API /config for ZEROCONFIGURATIONS)
	// it can only be ST type with 0 or blank hour
	checkZeroRows(isCorrect = false) {
		let tsRows = this.dataService.timesheetRows;
		if (isCorrect) {
			tsRows = this.dataService.timesheetCorrectRows;
			this.correctRowsZeroValid = true;
			this.correctRowsZeroValidity = [];
		} else {
			this.rowsZeroValid = true;
			this.rowsZeroValidity = [];
		}

		const self = this;
		tsRows.forEach(function (d, i) {
			self.rowsZeroValidity[i] = true;
			self.correctRowsZeroValidity[i] = true;

			const canEditCustomType = self.configService.canEditCustomTimesheetLineItem(d[0].type);
			const timesheetStatus = self.dataService.getTimesheetStatus();
			const shouldCheck = timesheetStatus === self.configService.timesheetSaveStatus;
			const canEdit = self.configService.canDo(self.configService.getDataObj(self.configService.timesheetDataObj).fields, self.configService.timeentryProp, 'edit');

			if (shouldCheck && canEdit && !canEditCustomType) {
				if(self.dataService && self.dataService.zeroConfigs && self.dataService.zeroConfigs['workitemid']) {
					self.dataService.zeroConfigs['workitemid'].forEach(workitemid => {
						if (d[0].account.workitemid === workitemid) {
							d.forEach(day => {
								if (day.value > 0 || day.type !== self.configService.invoiceStraightTimeProp) {
									if (isCorrect) {
										self.correctRowsZeroValid = false;
										self.correctRowsZeroValidity[i] = false;
									} else {
										self.rowsZeroValid = false;
										self.rowsZeroValidity[i] = false;
									}
								}
							});
						}
					});
				}
				// if (!d[0].account.ilcValid) {
				// 	self.rowsILCValid = false;
				// 	self.rowsILCValidity[i] = false;
				// }
			}
		});
	}

	hasAccount() {
		let hasAcct = true;
		for (let i = 0; i < this.dataService.timesheetRows.length; i++) {
			const account = this.dataService.timesheetRows[i][0].account;
			const type = this.dataService.timesheetRows[i][0].type;
			const customTypes = this.configService['customOptions'].filter(option => {
				return option.value === type;
			});
			const canEditCustomType = customTypes && customTypes.length > 0;
			if (!canEditCustomType && (!account.accountid || !account.workitemid || !account.activitycode || !account.activitydescription)) {
				hasAcct = false;
				break;
			}
		}
		return hasAcct;
	}

	hasILCClaimCodes() {
		let hasClaimCodes = false;
		for (let i = 0; i < this.dataService.timesheetRows.length; i++) {
			const account = this.dataService.timesheetRows[i][0].account;
			if (account.accountid || account.workitemid || account.activitycode || account.activitydescription) {
				hasClaimCodes = true;
				break;
			}
		}
		return hasClaimCodes;
	}

	typeSupported() {
		let supported = true;
		for (let i = 0; i < this.dataService.timesheetRows.length; i++) {
			const type = this.dataService.timesheetRows[i][0].type;
			const matchedTypes = this.dataService.quantityTypes.filter(qType => {
				return qType.type === type;
			});
			if (matchedTypes.length === 0) { // need check matched options
				const matchedOptions = this.configService['customOptions'].filter(option => {
					return option.active && option.value === type;
				});
				if (matchedOptions.length === 0) {
					supported = false;
				}
			}
		}
		return supported;
	}

	checkAccessRows() {
		this.rowsAccess = true;
		this.rowsAccessibility = [];

		const self = this;
		for (let i = 0; i < this.dataService.timesheetRows.length; i++) {
			const d = this.dataService.timesheetRows[i];

			// console.log('CHECK ACCESS ROW', d);
			self.rowsAccessibility[i] = true;

			const accountid = d[0].account.accountid;
			if (this.accountService.isDefaultOption(accountid)) {
				continue;
			}

			let canAccount = false;
			self.dataService.accounts.forEach(function (dAct, ii) {
				if (dAct.accountid === accountid) {
					canAccount = true;
				}
			});

			const workitemid = d[0].account.workitemid;
			let canWorkItem = false;
			const WIOptions = self.accountService.getWorkitemOptions(accountid);
			if (WIOptions && WIOptions.length > 0) {
				WIOptions.forEach(function (dWork, ii) {
					if (dWork === workitemid) {
						canWorkItem = true;
					}
				});
			}

			const activitycode = d[0].account.activitycode;
			let canActivityCode = false;
			const ACOptions = self.accountService.getActivitycodeOptions(accountid, workitemid);
			if (ACOptions && ACOptions.length > 0) {
				ACOptions.forEach(function (dCode, ii) {
					if (dCode === activitycode) {
						canActivityCode = true;
					}
				});
			}

			const billcode = d[0].account.billcode;
			let canBillCode = false;
			const BCOptions = self.accountService.getBillcodeOptions(accountid, workitemid, activitycode);
			if (BCOptions && BCOptions.length > 0) {
				BCOptions.forEach(function (dBill, ii) {
					if (dBill === billcode) {
						canBillCode = true;
					}
				});
			}

			if (!canAccount || !canWorkItem || !canActivityCode || !canBillCode) {
				self.rowsAccess = false;
				self.rowsAccessibility[i] = false;
			}
		}

		console.log('ROWS ACCESS', this.rowsAccessibility);
	}

	checkValidCorrectRows() {
		this.checkUniqueCorrectRows();
		this.checkAccessCorrectRows();
		this.checkILCValidCorrectRows();
		// need validate special TS correct row with zero hour configuration
		this.checkZeroRows(true);
	}

	checkILCValidCorrectRows() {
		this.rowsCorrectILCValid = true;
		this.rowsCorrectILCValidity = [];

		const self = this;
		this.dataService.timesheetCorrectRows.forEach(function (d, i) {
			console.log('CHECK ILC VALID ROW', d);
			self.rowsCorrectILCValidity[i] = true;
			const canEditCustomType = self.configService.canEditCustomTimesheetLineItem(d[0].type);
			const canEdit = self.configService.canDo(self.configService.getDataObj(self.configService.timesheetDataObj).fields, self.configService.timeentryProp, 'edit');

			if (d['newRow'] && canEdit && !canEditCustomType) {
				if (!d[0].account.ilcValid) {
					self.rowsCorrectILCValid = false;
					self.rowsCorrectILCValidity[i] = false;
				}
			}
		});
		console.log('ROWS VALIDITY', this.rowsCorrectILCValid);
	}

	checkUniqueCorrectRows() {
		this.rowsCorrectUnique = true;
		this.rowsCorrectUniqueness = [];

		const self = this;
		this.dataService.timesheetCorrectRows.forEach(function (d, i) {
			// console.log('CHECK UNIQUE CORRECT ROW', d);
			self.rowsCorrectUniqueness[i] = true;
			if (d[0].account.accountid !== undefined) {
				// create a unique signature for the row based on the account selections
				let rowSig = d[0].account.accountid + d[0].account.workitemid;
				if (d[0].account.workitemdescription) {
					rowSig += d[0].account.workitemdescription;
				}
				rowSig += d[0].account.activitycode + d[0].account.billcode + d[0].type;
				if (d[0].account.activitydescription) {
					rowSig += d[0].account.activitydescription;
				}
				// console.log('CORRECT ROW SIG', rowSig);
				// check this row against all other rows
				self.dataService.timesheetCorrectRows.forEach(function (dd, ii) {
					let rowSigCheck = dd[0].account.accountid + dd[0].account.workitemid;
					if (dd[0].account.workitemdescription) {
						rowSigCheck += dd[0].account.workitemdescription;
					}
					rowSigCheck += dd[0].account.activitycode + dd[0].account.billcode + dd[0].type;
					if (dd[0].account.activitydescription) {
						rowSigCheck += dd[0].account.activitydescription;
					}
					// console.log('CORRECT ROW SIG CHECK', rowSigCheck);
					// compare signatures but don't check against itself
					if (i !== ii && rowSig === rowSigCheck) {
						// if sigs match all rows are not unique
						self.rowsCorrectUnique = false;
						self.rowsCorrectUniqueness[i] = false;
						self.rowsCorrectUniqueness[ii] = false;
					}
				});
			}
		});
		console.log('CORRECT ROWS CORRECT VALIDITY', this.rowsCorrectUnique, this.rowsCorrectUniqueness);
	}

	checkAccessCorrectRows() {
		this.rowsCorrectAccess = true;
		this.rowsCorrectAccessibility = [];

		const self = this;
		this.dataService.timesheetCorrectRows.forEach(function (d, i) {
			// console.log('CHECK ACCESS ROW', d);
			self.rowsCorrectAccessibility[i] = true;

			const accountid = d[0].account.accountid;
			let canAccount = false;
			self.dataService.accounts.forEach(function (dAct, ii) {
				if (dAct.accountid === accountid) {
					canAccount = true;
				}
			});

			const workitemid = d[0].account.workitemid;
			let canWorkItem = false;
			self.accountService.getWorkitemOptions(accountid)?.forEach(function (dWork, ii) {
				if (dWork === workitemid) {
					canWorkItem = true;
				}
			});

			const activitycode = d[0].account.activitycode;
			let canActivityCode = false;
			self.accountService.getActivitycodeOptions(accountid, workitemid).forEach(function (dCode, ii) {
				if (dCode === activitycode) {
					canActivityCode = true;
				}
			});

			const billcode = d[0].account.billcode;
			let canBillCode = false;
			self.accountService.getBillcodeOptions(accountid, workitemid, activitycode).forEach(function (dBill, ii) {
				if (dBill === billcode) {
					canBillCode = true;
				}
			});

			if (!canAccount || !canWorkItem || !canActivityCode || !canBillCode) {
				self.rowsCorrectAccess = false;
				self.rowsCorrectAccessibility[i] = false;
			}

		});
		console.log('CORRECT ROWS CORRECT ACCESS', this.rowsCorrectAccess, this.rowsCorrectAccessibility);
	}

	saveTimesheet(timesheetStatus, ilcCheck = true) {
		console.log('SAVE TIMESHEET', this.dataService.timesheetRows, this.dataService.timesheetCorrectRows);
		if (this.dataService.contractorDetails.ilcenabled && ilcCheck && !this.hasAccount()) {
			this.noteService.displayWarning('Timesheet row is missing mandatory information which is preventing submission.  Please edit ILC account information');
			return;
		}

		// have to check type to support the existing TS when ilc contractor is converted from non-ilc
		if (this.dataService.contractorDetails.ilcenabled && ilcCheck && !this.typeSupported()) {
			this.noteService.displayWarning('Can not submit without required selection ST/OT.  Please select the ST/OT to submit time');
			return;
		}

		this.checkHourRules();
		if (!this.hoursAllowed) {
			return;
		}

		const timesheet = this._generateTimesheetforSubmit(timesheetStatus);
		// console.log('TIMESHEET ROWS', this.dataService.timesheetRows, allHours, timeEntries);
		console.log('SAVE TIMESHEET', timesheet);
		const supcontId = this.dataService.timesheetDetails[this.configService.supcontIdProp];
		const supplierId = this.dataService.timesheetDetails[this.configService.supplierIdProp];
		this.submitTimesheet(timesheet, supcontId, supplierId);
	}

	_generateTimesheetforSubmit(timesheetStatus) {
		const allHours = this.getAllHours(this.dataService.timesheetRows);
		const timeEntries = this.getTimeEntries(allHours, false);
		const correctHours = this.getAllHours(this.dataService.timesheetCorrectRows);
		let correctEntries = null;
		// Only put correction rows into data if timesheet is locked
		// Otherwise leave correction rows as null
		// This way regular rows are only copied over after timesheet is locked
		if (this.isLocked()) {
			correctEntries = this.getTimeEntries(correctHours, true);
		}
		const timesheet = {};
		timesheet[this.configService.poNumberProp] = this.dataService.timesheetDetails[this.configService.poNumberProp];
		timesheet[this.configService.contractorIdProp] = this.dataService.timesheetDetails[this.configService.contractorIdProp];
		timesheet[this.configService.supplierIdProp] = this.dataService.timesheetDetails[this.configService.supplierIdProp];
		timesheet[this.configService.contractorLineItemProp] = this.dataService.timesheetDetails[this.configService.contractorLineItemProp];
		timesheet[this.configService.startDateProp] = this.dataService.getTimesheetStart();
		timesheet[this.configService.endDateProp] = this.dataService.getTimesheetEnd();
		timesheet['contractorcomment'] = this.dataService.contractorcomment;
		const flexifields = [];
		if (this.dataService.reasoncode !== null) {
			flexifields.push({
				'key': 'reasoncode',
				'value': this.dataService.reasoncode['prop']
			});
		}

		timesheet[this.configService.timeentryProp] = {
			startdate: this.dataService.getTimesheetStart(),
			enddate: this.dataService.getTimesheetEnd(),
			timeentries: timeEntries,
			correctionentries: correctEntries,
			status: timesheetStatus,
			flexifields: flexifields,
			expenses: {
				total: this.dataService.totalExpenses
			},
			correctionexpenses: {
				total: this.dataService.correctExpenses
			}
		};
		return timesheet;
	}

	approveTimesheet(approvalStatus, approvalComment) {
		const approval = {};
		approval[this.configService.poNumberProp] = this.dataService.timesheetDetails[this.configService.poNumberProp];
		approval[this.configService.contractorIdProp] = this.dataService.timesheetDetails[this.configService.contractorIdProp];
		approval[this.configService.supcontIdProp] = this.dataService.timesheetDetails[this.configService.supcontIdProp];
		approval[this.configService.supplierIdProp] = this.dataService.timesheetDetails[this.configService.supplierIdProp];
		// approval['supplierctrid'] = this.dataService.timesheetDetails[this.configService.supcontIdProp];
		approval[this.configService.timesheetApprovalPeriodProp] = this.dataService.getTimesheetStart();
		approval[this.configService.timesheetCommentProp] = approvalComment;
		approval[this.configService.timesheetApprovalProp] = approvalStatus;

		console.log('APPROVE TIMESHEET', approval);
		this.processTimesheet(approval);
	}

	// DATA PARSERS

	getAllHours(rows) {
		const allHours = [];
		rows.forEach(function (row, rowI) {
			row.forEach(function (hour, hourI) {
				allHours.push(hour);
			});
		});
		return allHours;
	}

	/**
	 * Method to convert front-end data structure into back-end data structure
	 */
	getTimeEntries(hours, isCorrection) {

		const self = this;
		const timeEntries = [];
		// loop through all hours from each input on timesheet
		hours.forEach(function (hour, hourI) {

			// check of hours object is using a default time type
			// console.log('HOUR ACCOUNT', hour.account);
			const isDefaultOption = self.accountService.isDefaultOption(hour.account.accountid);
			// console.log('IS DEFAULT OPTION', isDefaultOption);

			// check if an entry has already been created for the date of the hour object
			const checkEntries = _.cloneDeep(timeEntries);
			const entryExists = self.entryExists(hour, checkEntries);

			if (!entryExists.exists) {
				// if an entry exists and the given hours of the check object is > 0
				// make a simple hours object for API call
				// make an entry structure with date from hour object
				// push hour to hours array within entry object
				// console.log('ENTRY DOES NOT EXIST');

				const entry = {};
				entry['activity'] = hour.date;
				if (self.dataService.timesheetDetails?.['timeentryforperiod']?.[0]) {
					entry['ilcenabled'] = self.getILCEnabled(self.dataService.timesheetDetails['timeentryforperiod'][0])
				} else {
					entry['ilcenabled'] = true;
				}
				
				entry['timeintimeout'] = [
					{
						timein: '00:00',
						timeout: '00:00'
					}
				];
				entry['hours'] = [];

				// if hours have been entered create & populate an hours object for back-end
				// if is a correction hour allow 0 hours so row persists
				// if (parseInt(hour.value, 10) > 0 || parseInt(hour.value, 10) < 0 || isCorrection) {
				// if (hour.value !== 0 || isCorrection) {
				const newHour = {};

				// if default time type is selected, populate an empty account object
				// otherwise use the selected account object but remove account description
				if (isDefaultOption) {
					newHour['account'] = {};
				} else {
					newHour['account'] = self.convertUIAccount(hour.account);
					// delete newHour['account']['activitydescription'];
				}

				newHour['key'] = hour.key;
				newHour['value'] = hour.value;
				newHour['type'] = hour.type;
				// newHour['type'] = 'straighttime';

				entry['hours'].push(newHour);
				// }
				timeEntries.push(entry);
			} else {
				// console.log('ENTRY EXISTS');

				// else check if hours are > 0 then simplify hours obj for API call and push to found entry object's hours array
				// if is a correction hour allow 0 hours so row persists
				// if (parseInt(hour.value, 10) > 0 || parseInt(hour.value, 10) < 0 || isCorrection) {
				// if (hour.value !== 0 || isCorrection) {
				const newHour = {};

				// if default time type is selected, populate an empty account object
				// otherwise use the selected account object but remove account description
				if (isDefaultOption) {
					newHour['account'] = {};
				} else {
					newHour['account'] = self.convertUIAccount(hour.account);
					// delete newHour['account']['activitydescription'];
				}

				newHour['key'] = hour.key;
				newHour['value'] = hour.value;
				newHour['type'] = hour.type;
				// newHour['type'] = 'straighttime';

				timeEntries[entryExists.index].hours.push(newHour);
				// }
			}
		});
		return timeEntries;
	}

	entryExists(hour, entries) {

		const entryExists = {
			exists: false,
			index: -1
		};
		entries.forEach(function (d, i) {
			if (d.activity === hour.date) {
				entryExists.exists = true;
				entryExists.index = i;
			}
		});
		// console.log('ROW EXISTS', rowExists, hour, rows);
		return entryExists;
	}

	/**
	 * Method to convert back-end data structure into front-end data structure
	 */
	getRows(isCorrection): Array<any> {
		console.log('GET ROWS', isCorrection);

		const self = this;
		let newSheet = false;
		let timeEntries = this.dataService.getTimeEntries(isCorrection);
		if (timeEntries === null && this.isLocked) {
			timeEntries = this.dataService.getTimeEntries(false);
			newSheet = true;
		}

		const weekStartDate = new Date(this.dataService.getTimesheetStart());
		const contractorStart = new Date(this.dataService.getTimesheetContractorStart());
		const contractorEnd = new Date(this.dataService.getTimesheetContractorEnd());
		let lastActivityDate: Date;
		let firstActivityDate: Date;
		const rows = [];
		const allHours = [];

		// enhance hour objects and push them all to a flat array
		timeEntries.forEach(function (timeEntry) {
			timeEntry.hours.forEach(function (hour) {
				const enhancedHour = self.makeEnhancedHour(hour, timeEntry.activity);
				if (isCorrection && newSheet) {
					enhancedHour.value = 0;
				}
				enhancedHour.account.ilcValid = true;
				allHours.push(enhancedHour);
			});
			// keep track of dates returned from backend, even if they have no hours, so week can be truncated if needed
			lastActivityDate = new Date(timeEntry.activity);
			firstActivityDate = firstActivityDate ? firstActivityDate : new Date(timeEntry.activity);
		});

		// if this is a new timesheet and no hours exist create one so it can be used to fill row
		if (allHours.length === 0) {
			if (this.dataService.accounts[0] !== undefined && this.dataService.accounts[0].accountid) {
				const accountid = this.dataService.accounts[0].accountid;
				const workitems = this.dataService.accounts[0].workitems;
				// if contractor has accounts (ilc) then create an hours object with top level account selected
				if (accountid !== '' && workitems !== null && workitems !== undefined) {
					try {
						let workitemid = this.dataService.accounts[0].workitems[0].workitemid;
						const groupid = this.dataService.accounts[0].workitems[0].groupid;
						if (groupid) {
							workitemid += ' : ' + groupid;
						}
						const activitycode = this.dataService.accounts[0].workitems[0].activitycodes[0].activitycode;
						const activitydescription = this.dataService.accounts[0].workitems[0].activitycodes[0].activitydescription;
						const billcode = this.dataService.accounts[0].workitems[0].activitycodes[0].billcodes[0];
						allHours.push(
							{
								key: accountid,
								value: null,
								type: this.dataService.quantityTypes[0].type,
								account: {
									accountid: this.dataService.accounts[0].accountid,
									workitemid: workitemid,
									groupid: groupid,
									activitycode: activitycode + ' : ' + activitydescription,
									activitydescription: activitydescription,
									billcode: billcode
								}
							}
						);
					} catch (e) {
						console.log('NO ACCOUNTS ERROR', e);
					}
				}
			} else {
				console.log('NO TIMESHEET ROWS', this.dataService.contractorDetails);
				// if ILC contractor
				if (this.dataService.contractorDetails[this.configService.contractorILCProp]) {
					// if contractor has no accounts then create an hours object with empty
					// account objects so submission will be prevented and alert shown that user
					// has no accounts to access
					allHours.push(
						{
							key: '',
							value: null,
							type: '',
							account: {
								accountid: '',
								workitemid: '',
								groupid: '',
								activitycode: '',
								activitydescription: '',
								billcode: ''
							}
						}
					);
				} else {
					// if non ILC contractor
					console.log('DEFAULT ACCOUNT OPTIONS', this.configService.defaultOptions);
					allHours.push(
						// if contractor has no accounts then create an hours object with top level default time type selected
						{
							key: this.configService.defaultOptions[0].value,
							value: null,
							type: this.configService.defaultOptions[0].value,
							account: {
								accountid: this.configService.defaultOptions[0].value,
								workitemid: '',
								groupid: '',
								activitycode: '',
								activitydescription: '',
								billcode: ''
							}
						}
					);
				}
			}
		}

		// take all enhanced hour objects and put them in rows
		// create row if one doesn't already exists for hour object based on enhanced hour row param
		allHours.forEach(function (hour) {
			if (self.dataService.isTimesheetNew()) {
				hour.value = undefined;
			}
			const checkRows = _.cloneDeep(rows);
			const rowExists = self.rowExists(hour, checkRows);
			if (!rowExists.exists) {
				const row = [];
				row.push(hour);
				rows.push(row);
			} else {
				rows[rowExists.index].push(hour);
			}
		});

		console.log('TIMESHEET ROWS', isCorrection, rows);

		// determine if week is truncated
		this.trimmedSheet = false;
		if (weekStartDate < contractorStart || lastActivityDate > contractorEnd) {
			// if contractor start or end date truncates week
			this.trimmedSheet = true;
			this.trimmedSheetReason = self.trimmedSheetReasons.contractorStardEndDate;
		}
		if (this.dataService.timesheetDetails.transition) {
			// if week is truncated due to it being the kyndryl cutover week
			this.trimmedSheetReason = this.trimmedSheetReasons.ibmToKyndrylCutover;
			this.trimmedSheet = true;
		}

		// use the week's earliest end date, or latest start date, either the contractor's end/start date or if the backend didn't send a full week
		const fillRowLimitEnd = lastActivityDate < contractorEnd ? lastActivityDate : contractorEnd;
		const fillRowLimitStart = firstActivityDate > contractorStart ? firstActivityDate : contractorStart;
		// fill rows before returning them
		return this.fillRows(rows, weekStartDate, fillRowLimitStart, fillRowLimitEnd);
	}

	convertUIAccount(account) {
		// console.log('CONVERT UI ACCOUNT', account);
		const newAccount = _.cloneDeep(account);
		const activityCode = newAccount.activitycode;
		if (activityCode !== undefined) {
			if (activityCode.indexOf(' : ') > 0) {
				newAccount.activitycode = activityCode.split(' : ')[0];
				newAccount.activitydescription = activityCode.split(' : ')[1];
			}
		}
		const workItemid = newAccount.workitemid;
		if (workItemid) {
			if (workItemid.indexOf(' : ') > 0) {
				newAccount.workitemid = workItemid.split(' : ')[0];
				newAccount.groupid = workItemid.split(' : ')[1];
			}
		}
		// console.log('CONVERTED UI ACCOUNT', newAccount);
		return newAccount;
	}

	makeEnhancedHour(hour, date) {
		const enhancedHour = _.cloneDeep(hour);
		// add date & row param to hour object to use in sorting and row identification
		enhancedHour.date = date;
		enhancedHour.row = hour.key;
		if (hour.account !== undefined) {
			if (hour.account.accountid !== undefined && hour.account.accountid !== '') {
				try {
					// add unique row for unique identification
					enhancedHour.row = hour.account.accountid + hour.account.workitemid + hour.account.activitycode + hour.account.billcode;
					if (hour.account.activitydescription) {
						enhancedHour.row += hour.account.activitydescription;
					}
					// if (hour.account.groupid) {
					// 	enhancedHour.account.workitemid = hour.account.workitemid + ' : ' + hour.account.groupid;
					// }
					// convert hours accounts to concat activity code & activity description
					// enhancedHour.account.activitycode = hour.account.activitycode + ' : ' + hour.account.activitydescription;
				} catch (e) {
					console.log('ERROR MAKING ENHANCED HOUR', e);
				}
			}
		}

		return enhancedHour;
	}

	rowExists(hour, rows) {
		const rowExists = {
			exists: false,
			index: -1
		};
		rows.forEach(function (d, i) {
			if (d[0].row === hour.row && d[0].type === hour.type) {
				rowExists.exists = true;
				rowExists.index = i;
			}
		});
		// console.log('ROW EXISTS', rowExists, hour, rows);
		return rowExists;
	}

	/**
	 * Populates days in rows with hours, and starting any new days with an empty hour
	 */
	fillRows(rows: Array<any>, startDate: Date, earliestDate: Date, latestDate: Date): Array<any> {
		console.log('FILL ROWS', rows, startDate.getUTCDate(), ' - ', earliestDate.getUTCDate(), ' - ', latestDate.getUTCDate());

		const self = this;

		// filled rows will have an hour object for every day of the week
		const filledRows = [];

		// loop through all rows and fill them
		rows.forEach(function (row) {
			const filledRow = [];
			// create real date object from string so we can increment
			const thisDayStart = new Date(startDate.getTime());
			console.log('FILL ROW START', startDate, thisDayStart.getUTCDate(), earliestDate.getUTCDate());
			// use weekDay array to make hour oject for each day of the week if one doesn't exist in the row
			self.configService.weekDays.forEach(function () {
				// check to make sure dates added to row are within limited start & end dates
				if (thisDayStart >= earliestDate && thisDayStart <= latestDate) {
					// get date string matching hour's date format to use to check if any hours exist for this date
					const dateString = self.dataService.formatDate(thisDayStart);
					let matchedHour = -1;
					// check each item in the row to see if it matches this date
					row.forEach(function (hour, hourI) {
						if (hour.date === dateString) {
							matchedHour = hourI;
						}
					});
					if (matchedHour > -1) {
						// if the row has an hour for this date push it to filled row
						filledRow.push(row[matchedHour]);
					} else {
						// else make an empty hour from existing hour setting value to 0 and date to this date and push it to filled row
						const emptyHour = _.cloneDeep(row[0]);
						// we cannot remove this line as it sets the hours to zero for the cloned day
						// if cloned day has any hours they will be incorrectly added to day that needs empty hours object
						emptyHour.value = undefined;
						emptyHour.date = dateString;
						filledRow.push(emptyHour);
					}
				}
				// increment date object before loop continues
				thisDayStart.setUTCDate(thisDayStart.getUTCDate() + 1);
			});
			filledRows.push(filledRow);
		});

		return filledRows;
	}

	sortHours(a, b) {
		if (a.date < b.date) {
			return -1;
		}
		if (a.date > b.date) {
			return 1;
		}
		return 0;
	}

	/**
	 * Method to calculate total hours as timesheet edits are made
	 */
	calculateTotal(): void {
		// early out if nonBillableCodes haven't been retrieved yet
		if (this.nonBillableCodes === undefined) return;

		const totalHoursByType = {
			billable: 0
		};

		const dailyHoursByType = {
			nonbillable: []
		};

		// this method is used for TS details page and should be safe to use timesheetDetails.countrycode
		const hourTypes = this.configService.getCountryConfig('hourTypes', this.dataService.timesheetDetails.countrycode);	
		hourTypes.forEach(type => { 
			dailyHoursByType[type] = [];
			totalHoursByType[type] = 0;
		});

		const numHourDecimals = this.dataService.contractorDetails.ilcenabled ? 1 : 2;

		if (Array.isArray(this.dataService.timesheetRows) && this.dataService.timesheetRows.length > 0) {
			this.dataService.timesheetRows.forEach((week) => {
				week.forEach((d, i) => {
					let hoursValue = d.value;
					if (hoursValue === undefined || hoursValue === null) {
						hoursValue = 0;
					}

					hoursValue = this.roundToDecimal(hoursValue, numHourDecimals);

					hourTypes.forEach(type => {
						if (d.type === type) {
							if (dailyHoursByType[type][i] === undefined) {
								dailyHoursByType[type][i] = hoursValue;
							} else {
								dailyHoursByType[type][i] = Number(dailyHoursByType[type][i]) + Number(hoursValue);
							}
							totalHoursByType[type] = Number(totalHoursByType[type]) + Number(hoursValue);
						}
					});

					// add to billable hours if work item is billable (not a non-billable code, and not a custom line item)
					if (this.checkIfBillable(d)) {
						totalHoursByType['billable'] = Number(totalHoursByType['billable']) + Number(hoursValue);
					} else {
						if (dailyHoursByType['nonbillable'][i] === undefined) {
							dailyHoursByType['nonbillable'][i] = hoursValue;
						} else {
							dailyHoursByType['nonbillable'][i] = Number(dailyHoursByType['nonbillable'][i]) + Number(hoursValue);
						}
					}
				});
			});
		}
		if (Array.isArray(this.dataService.timesheetCorrectRows) && this.dataService.timesheetCorrectRows.length > 0) {
			this.dataService.timesheetCorrectRows.forEach((week) => {
				week.forEach((d) => {
					// if not billable, just skip this forEach iteration
					if (!this.checkIfBillable(d)) return;

					let hoursValue = d.value;
					if (hoursValue === undefined || hoursValue === null) {
						hoursValue = 0;
					}
					hoursValue = this.roundToDecimal(hoursValue, numHourDecimals);
					totalHoursByType['billable'] = Number(totalHoursByType['billable']) + Number(hoursValue);
				});
			});
		}

		// round to required number of decimals
		hourTypes.forEach(type => {
			totalHoursByType[type] = this.roundToDecimal(totalHoursByType[type], numHourDecimals);
		});
		totalHoursByType['billable'] = this.roundToDecimal(totalHoursByType['billable'], numHourDecimals);
		this.dataService.totalBillableHours = Number.isNaN(totalHoursByType['billable']) ? 0 : totalHoursByType['billable'];


		// check if notification needs to be shown for over hours
		// US uses standard for type instead of straighttime
		const totalSHours = totalHoursByType['straighttime'] + totalHoursByType['standard'];
		if (totalHoursByType['overtime'] > 0 && totalSHours < 40) {
			this.noteMessage = 'Timesheet has overtime without having 40 hours of standard time ';
		} else if (totalSHours > 40 && totalHoursByType['overtime'] === 0) {
			this.noteMessage = 'Timesheet has over 40 hours of standard time.Timesheet should now bill overtime';
		} else {
			this.noteMessage = '';
		}

		// this has been used to display msg in TS details page
		this.dataService.totalOTHours = Number.isNaN(totalHoursByType['overtime']) ? 0 : totalHoursByType['overtime'];

		hourTypes.forEach(type => {
			dailyHoursByType[type].forEach((d, i) => {
				dailyHoursByType[type][i] = this.roundToDecimal(d, numHourDecimals);
			});
			this.dataService.dailyHoursByType[type] = dailyHoursByType[type];
		});
		
		dailyHoursByType['nonbillable'].forEach((d, i) => {
			dailyHoursByType['nonbillable'][i] = this.roundToDecimal(d, numHourDecimals);
		});
		this.dataService.dailyHoursByType['nonbillable'] = dailyHoursByType['nonbillable'];
	}

	checkHourRules() {
		if (this.dataService.timesheetDetails?.countrycode === this.configService.countryCodes.US) return;

		const dayTotalsByType = this.calculateDayTotalsByType();
		this.hoursAllowed = dayTotalsByType.every(dayTotals => this.applyHourRules(this.dataService.contractorDetails, dayTotals));
	}

	/**
	 * take the day object from the calculateTotal function and compare it against non-billable criteria
	 */
	checkIfBillable(dayObject) {
		if (dayObject.account) {
			if (dayObject.account.workitemid.length > 0) {
				if (this.nonBillableCodes.includes(dayObject.account.workitemid)) {
					return false;
				}
			} else {
				if (this.configService.customOptions.filter(x => x.value === dayObject.type).length > 0) {
					return false;
				}
			}
		}
		return true;
	}

	/**
	 * Gets billable and nonbillable hours. Returns billable hours, and sets nonbillable to this.totalNonbillableHours
	 */
	getTimesheetHours(timeentryforperiod, iscrrreconciled = true, nonbillableCodes: Array<string> = [], countryCode = null): any {
		const timeentries = timeentryforperiod.timeentries;
		const correctionentries = timeentryforperiod.correctionentries;
		const self = this;

		// accumulate hours into either billable or nonbillable
		const hours = { billable: 0, nonbillable: 0};
		const hourTypes = this.configService.getCountryConfig('hourTypes', countryCode);
		hourTypes.forEach(type => {
			hours[this.configService.totalHourTypes[type]] = 0;
		});
		this.accumulateTimesheetHours(timeentries, nonbillableCodes, hours, countryCode);
		if (correctionentries && iscrrreconciled) {
			this.accumulateTimesheetHours(correctionentries, nonbillableCodes, hours, countryCode);
		}

		if (!Number.isInteger(hours.billable)) {
			hours.billable = this.roundToDecimal(hours.billable, 2);
		}
		if (!Number.isInteger(hours.nonbillable)) {
			hours.nonbillable = this.roundToDecimal(hours.nonbillable, 2);
		}

		Object.keys(hours).forEach( type => {
			if (!Number.isInteger(hours[type])) {
				hours[type] = this.roundToDecimal(hours[type], 2);
			}
		});

		this.totalNonbillableHours = hours.nonbillable;
		return hours;
	}

	/**
	 * Accumulate hours from timeEntryList and accumulated into two sums, billable and nonbillable
	 * @param timeEntryList list of objects containing the hour data
	 * @param nonbillableCodes list of strings containing codes which, if matching a time entry 'account.workitemid', will be counted as nonbillable
	 * @param hours object containing billable and nonbillable hours to be modified
	 */
	accumulateTimesheetHours(timeEntryList: Array<any>, nonbillableCodes: Array<string>, hours, countryCode = null): void {
		const hourTypes = this.configService.getCountryConfig('hourTypes', countryCode);
		for (const entry of timeEntryList) {
			for (const time of entry.hours) {
				if (!nonbillableCodes.includes(time.account.workitemid)) {
					hourTypes.forEach(type => {
						if (time.type === type) {
							hours[this.configService.totalHourTypes[type]] = Number(hours[this.configService.totalHourTypes[type]]) + Number(time.value);
							hours.billable = hours.billable + Number(time.value);
						}
					});

					if (!(hourTypes.includes(time.type))) {
						// add custom line items to non-billable hours
						// NOTE: the timesheet details page does this calculation by retrieving custom line items
						// in the function 'checkIfBillable'. those could be made the same at some point, but for now,
						// the timesheet bulk page doesn't retrieve that list of custom line items
						hours.nonbillable = Number(hours.nonbillable) + Number(time.value);
					}
				} else {
					// add specifically non-billable coded items to non-billable hours
					hours.nonbillable = Number(hours.nonbillable) + Number(time.value);
				}
			}
		}
	}

	getTimesheetStatus(timerecord) {
		let status = timerecord[this.configService.timesheetStatusProp];
		const rejected = this.configService.timesheetRejectedStatus;
		if (status === rejected) {
			const approvalProp = this.configService.timesheetApprovalObjProp;
			const SAMStatusProp = this.configService.timesheetSAMApprovalStatusProp;
			const PMStatusProp = this.configService.timesheetPMApprovalStatusProp;
			try {
				if (timerecord[approvalProp][SAMStatusProp] === rejected
					&& timerecord[approvalProp][PMStatusProp] !== rejected) {
					status = this.configService.timesheetSAMRejectedStatus;
				} else if (timerecord[approvalProp][PMStatusProp] === rejected
					&& timerecord[approvalProp][SAMStatusProp] !== rejected) {
					status = this.configService.timesheetPMRejectedStatus;
				}
			} catch (error) {
				console.log('Error occurred during retriving persona approval status.');
				status = timerecord[this.configService.timesheetStatusProp];
			}
		}
		return status;
	}

	getTimesheetStart(timeentry) {
		return timeentry[this.configService.timesheetStartProp];
	}

	getTimesheetEnd(timeentry) {
		return timeentry[this.configService.timesheetEndProp];
	}

	getILCEnabled(timeentry) {
		let ilcenabled = false;
		if (timeentry.timeentries[0]) {
			ilcenabled = timeentry.timeentries[0][this.configService.contractorILCProp];
		}
		return ilcenabled;
	}

	getTimesheetApprovalDate(timesheetentry, timestamp = false) {
		let approvalDateString = timesheetentry.approval[this.configService.timesheetApprovalTimeProp];
		if (approvalDateString) {
			if (timestamp) {
				approvalDateString = this.dataService.formatDateTime(approvalDateString);
			} else {
				approvalDateString = this.dataService.formatDate(this.dataService.convertMomentToDate(approvalDateString));
			}
		}
		return approvalDateString;
	}

	needsRecepit(isCorrection) {
		let needsRecepit = false;
		let expenses = this.dataService.totalExpenses;
		if (isCorrection) {
			expenses = this.dataService.correctExpenses;
		}
		const receiptDocs = this.dataService.getTimesheetDocs('expenses-proof').length;
		if (expenses >= this.configService.timesheetReceiptVal && receiptDocs === 0) {
			needsRecepit = true;
		}
		return needsRecepit;
	}

	isLocked() {
		const isLocked = this.dataService.getTimeLock();
		// const isLocked = true;
		// console.log('IS LOCKED', isLocked);
		return isLocked;
	}

	hasBreakdown(isCorrection) {
		let hasBreakdown = false;
		const breakdownDocs = this.dataService.getTimesheetDocs('expenses-breakdown').length;
		let expenses = this.dataService.totalExpenses;
		if (isCorrection) {
			expenses = this.dataService.correctExpenses;
		}
		// console.log('HAS BREAKDOWN', breakdownDocs, expenses);
		if (breakdownDocs > 0 || expenses === 0) {
			hasBreakdown = true;
		}
		return hasBreakdown;
	}

	canSubmit() {
		let canSubmit = false;
		// removed rows blank since we search for accounts now
		if (this.rowsUnique && this.hasBreakdown(false) && !this.needsRecepit(false) && !this.moreThanDailyAllowedHours && this.hoursAllowed) {
			canSubmit = true;
		}
		if (this.dataService.contractorDetails.ilcenabled) {
			if (!this.rowsILCValid || !this.rowsZeroValid) {
				canSubmit = false;
			}
		}

		// nonILC contractor cannot submit TS if TS hours locked (disablecontractoredit = tru)
		if (!this.dataService.contractorDetails.ilcenabled && this.userService.isContractor() && this.dataService.isTimesheetHoursLock()) {
			canSubmit = false;
		}
		canSubmit = this.isOvertimeZero(canSubmit, false);
		return canSubmit;
	}

	private isOvertimeZero(canSubmit: boolean, isCorrection: boolean) {
		let rows = this.dataService.timesheetRows;
		if(isCorrection){
			rows = this.dataService.timesheetCorrectRows;
		}
		rows.forEach(row => {
			let rowExists = false;
			let totalHoursByType = 0;
			let count = 0;
			row.forEach((cell) => {
				if (cell.type === 'overtime') {
					rowExists = true;
					totalHoursByType = totalHoursByType + Number(cell.value);
					if(cell.value === 0 ){
						count = count+1;
					}
				}
			});
			if (rowExists && totalHoursByType===0 && count>=6) {
				canSubmit = false;
				this.noteMessage = 'Overtime hours should be greater than 0 else please remove the overtime row(s).';
			}
		});
		return canSubmit;
	}

	canSubmitCorrection() {
		let canSubmit = false;
		// removed rows blank since we search for accounts now
		if (this.rowsCorrectUnique && this.hasBreakdown(true) && !this.needsRecepit(true) && !this.moreThanDailyAllowedHours && this.hoursAllowed) {
			canSubmit = true;
		}
		if (this.dataService.contractorDetails.ilcenabled) {
			if (!this.rowsCorrectILCValid || !this.correctRowsZeroValid) {
				canSubmit = false;
			}
		}
		//canSubmit = this.isOvertimeZero(canSubmit, true);
		return canSubmit;
	}

	expensesChange() {
		if (!this.dataService.totalExpenses) {
			this.dataService.totalExpenses = 0;
		}
	}

	/*
	expensesChange() {
		const totalExpeses = this.dataService.totalExpenses;
		const fund = this.getAvailableFund();
		if (fund === -1 || totalExpeses <= 0 || fund >= totalExpeses) {
			this.sufficientfunds = true;
		} else {
			this.sufficientfunds = false;
		}
	}

	getAvailableFund() {
		let fund = -1;
		const contractor = this.dataService.contractorDetails;
		const poDetails = this.dataService.poDetails;
		if (contractor && poDetails && poDetails['items']) {
			poDetails['items'].forEach((item) => {
				if (item['uuid'] === contractor['poconnector']) {
					fund = item.expense.tobedeliveredvalue;
				}
			});
		} else {
			console.error('Something is going wrong! Either contractor or PO details or items in PO is not available');
		}
		return fund;
	}
	*/

	//
	// API CALLS
	//

	loadTimesheets(data, loadAll = false) {
		const self = this;
		if (!loadAll) {
			this.displayService.activateLoadingTab(data, this.tabsData.listTabs);
		}

		if (this.userManagedCountrySelection) {
			data['countrycode'] = this.userManagedCountrySelection.prop;
		}

		this.commsService.getTimesheetList(data, loadAll, this.nonBillableCodes).subscribe((res) => {
			if (!loadAll) {
				this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			}
			console.log('LOAD TIMESHEETS RES: ', res);

			const successData = self.commsService.getSuccessData(res.timesheets);
			const count = self.commsService.getSuccessCount(res.timesheets);
			this.nonBillableCodes = self.commsService.getSuccessData(res.nonbillablecodes).ilccodes;
			let timesheets = [];
			if (Array.isArray(successData) && successData.length > 0) {
				timesheets = self.configService.getTableData(successData, self.dataObj);
				timesheets.forEach((d, i) => {
					self._parseTimesheet(d, this.nonBillableCodes, d[self.configService.countryCodeProp]);
				});
			}

			if (!loadAll) {
				const dataRef = self.dataObj + '-' + data.prop + '-' + data.type;
				self.dataService.updatePageData(dataRef, data, timesheets);
				self.dataService.updateDataCount(dataRef, count);
			} else {
				self.dataService.broadcastLoadAll(timesheets);
			}

		}, (err) => {
			if (!loadAll) {
				self.displayService.endLoading();
			}
			self.commsService.handleAPIError('Load Timesheets', err);
		});
	}

	_parseTimesheet(d, nonbillableCodes: Array<string>, countryCode = null): void {
		d[this.configService.timesheetInqueueProp] = this.getTimesheetInqueue(d.queuestatus);
		d[this.configService.contractorILCProp] = this.getILCEnabled(d.timeentryforperiod[0]);
		d[this.configService.timesheetHasCorrectionProp] = d.timeentryforperiod[0].correctionentries != null;
		d.pmemail = d.acl.pm.participants[0];
		d.samemail = d.acl.sam.participants[0];
		d.traemail = d.acl.tra.participants.length > 0 ? d.acl.tra.participants[0] : '';
		const hours = this.getTimesheetHours(d.timeentryforperiod[0], true, nonbillableCodes, countryCode);
		d[this.configService.timsheetHoursProp] = hours['billable'];
		Object.keys(hours).forEach(type => {
			d[type] = hours[type];
		});

		this._parseContractorTimesheet(d);
	}

	getTimesheetInqueue(queueStatus) {
		let inQueue = false;
		if (queueStatus && queueStatus[this.configService.persona]) {
			inQueue = queueStatus[this.configService.persona];
		}
		return inQueue;
	}

	loadContractorTimesheets(data, loadAll = false) {
		const self = this;
		const startDate = this.dataService.timesheetsRange[this.configService.startDateProp];
		const endDate = this.dataService.timesheetsRange[this.configService.endDateProp];

		if (!loadAll) {
			// this.displayService.startLoading();
			this.displayService.activateLoadingTab(data, this.tabsData.contractorListTabs);
		}
		this.commsService.getContractorTimesheetList(data, this.contractorPO, this.contractorId, this.contractorSupplierId, startDate, endDate).subscribe((res) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.contractorListTabs);
			}
			console.log('LOAD CONTRACTOR TIMESHEETS RES: ', res.timesheets);

			const successData = self.commsService.getSuccessData(res.timesheets);
			const count = self.commsService.getSuccessCount(res.timesheets);
			const nonbillableCodes = self.commsService.getSuccessData(res.nonbillablecodes).ilccodes;
			let timesheets = [];
			if (Array.isArray(successData) && successData.length > 0) {
				timesheets = _.cloneDeep(successData);
				timesheets.forEach(function (d, i) {
					const hours = self.getTimesheetHours(d.timeentryforperiod[0], true, nonbillableCodes, d[self.configService.countryCodeProp]);
					d[self.configService.timsheetHoursProp] = hours['billable'];
					Object.keys(hours).forEach(type => {
						d[type] = hours[type];
					});
					self._parseContractorTimesheet(d);
				});
			}

			if (!loadAll) {
				const dataRef = self.dataObj + '-' + data.prop + '-' + data.type;
				self.dataService.updatePageData(dataRef, data, timesheets);
				self.dataService.updateDataCount(dataRef, count);
			} else {
				self.dataService.broadcastLoadAll(timesheets);
			}

		}, (err) => {
			if (!loadAll) {
				self.displayService.endLoading();
			}
			self.commsService.handleAPIError('Load Contractor Timesheets', err);
		});
	}

	_parseContractorTimesheet(d) {
		d[this.configService.timesheetStatusProp] = this.getTimesheetStatus(d.timeentryforperiod[0]);
		d[this.configService.timesheetStatusUIProp] = this.dataService.convertApproveString(d[this.configService.timesheetStatusProp]);
		d[this.configService.timsheetNonbillableHoursProp] = this.totalNonbillableHours;
		d[this.configService.timesheetStartProp] = this.getTimesheetStart(d.timeentryforperiod[0]);
		d[this.configService.timesheetEndProp] = this.getTimesheetEnd(d.timeentryforperiod[0]);
		d[this.configService.timesheetIsCRRReconciledProp] = d.timeentryforperiod[0][this.configService.timesheetIsCRRReconciledProp];
		d[this.configService.timesheetApprovalTimeProp] = this.getTimesheetApprovalDate(d.timeentryforperiod[0]);
		if (d[this.configService.timesheetMigrationProp] &&
			d[this.configService.timesheetMigrationProp][this.configService.timesheetMigrationUIProp]) {
			d[this.configService.timesheetMigrationProp + '.' + this.configService.timesheetMigrationUIProp]
				= this.dataService.formatDateFromString(d[this.configService.timesheetMigrationProp][this.configService.timesheetMigrationUIProp]);
		}
		d[this.configService.timesheetHasExpensesProp] = this.getTimesheetHasExpenses(d.timeentryforperiod[0]);
		if (!d[this.configService.contractorILCProp] && d[this.configService.ilcSerialNumProp]) {
			d[this.configService.ilcSerialNumProp] = '';
		}
	}

	retrieveInvoiceTimesheets(bctimesheets, nonbillableCodes: Array<string>) {
		let timesheets = [];
		timesheets = _.cloneDeep(bctimesheets);
		const self = this;
		timesheets.forEach(function (d, i) {
			const iscrrreconciled = d.timeentryforperiod[0][self.configService.timesheetIsCRRReconciledProp];
			const hours = self.getTimesheetHours(d.timeentryforperiod[0], iscrrreconciled, nonbillableCodes, d[self.configService.countryCodeProp]);
			d[self.configService.timsheetHoursProp] = hours['billable'];
			
			Object.keys(hours).forEach(type => {
				d[type] = hours[type];
			});
			
			self._parseContractorTimesheet(d);
			if (!d.timeentryforperiod[0][self.configService.timesheetIsCRRReconciledProp]) {
				d[self.configService.timesheetStatusProp] = self.configService.timesheetApprovalStatus;
				d[self.configService.timesheetStatusUIProp] = self.dataService.convertApproveString(d[self.configService.timesheetStatusProp]);
			}
		});
		return timesheets;
	}

	loadTimesheet(poNumber, contractorId, supcontId, supplierId, date, showSpinner = true, copyclaimcodes = null) {

		console.log('LOAD TIMESHEET', poNumber, contractorId, supcontId, supplierId, date, showSpinner, copyclaimcodes);

		const self = this;
		this.loading = false;
		if (showSpinner) {
			this.displayService.startLoading();
		} else {
			this.loading = true;
			this.dataService.clearTimesheetRows();
		}
		this.dataService.reasoncode = null;
		let checkDuplicateTimesheet = false;
		if (this.userService.persona === this.configService.personaProps.sam ||
			this.userService.persona === this.configService.personaProps.contractor && this.dataService.contractorPOs?.length > 1) {
				checkDuplicateTimesheet = true;
		}
		this.commsService.getTimesheet(poNumber, contractorId, supcontId, supplierId, date, checkDuplicateTimesheet, copyclaimcodes).subscribe((res) => {
			if (showSpinner) {
				self.displayService.endLoading();
			} else {
				this.loading = false;
			}
			console.log('LOAD TIMESHEET RES: ', res);
			const successData = self.commsService.getSuccessData(res);
			self._updateDataService(successData);
			self.loadTimesheetDocs();
			self.checkSubmitIdentity();
			self.dataService.broadcastTimesheetLoadCompleted();
			// display warning msg if copy claim codes is not completely successful
			if (copyclaimcodes && successData.copyclaimcodes?.error) {
				self.noteService.displayWarning(successData.copyclaimcodes.error);
			}
			// display error if site location is empty on new timesheet
			if (successData.createnewtimesheeterror) {
				self.noteService.displayError(successData.createnewtimesheeterror.error);
			}
		}, (err) => {
			if (showSpinner) {
				self.displayService.endLoading();
			} else {
				this.loading = false;
			}
			self.commsService.handleAPIError('Load Timesheet', err);
			self.router.navigateByUrl(self.configService.contractorDataObj + '/' + poNumber + '/' + contractorId + '/' + supplierId);
		});
	}

	_updateDataService(successData) {
		this.currency = successData[this.configService.timesheetCurrencyProp];
		successData[this.configService.timesheetApprovalTimeProp] = this.getTimesheetApprovalDate(successData.timeentryforperiod[0], true);
		if (successData[this.configService.timesheetLatestSubmissionDateProp]) {
			successData[this.configService.timesheetLatestSubmissionDateProp] = this.dataService.formatDate(this.dataService.convertMomentToDate(successData[this.configService.timesheetLatestSubmissionDateProp]));
		}
		successData[this.configService.timesheetStatusProp] = this.getTimesheetStatus(successData.timeentryforperiod[0]);
		successData[this.configService.timesheetStatusUIProp] = this.dataService.convertApproveString(successData[this.configService.timesheetStatusProp]);

		this.dataService.updateTimesheet(successData);

		if (this.contractorILCUpdated) {
			this.dataService.contractorDetails[this.configService.contractorILCProp] = this.originalILCFromContractor;
		}

		// two lines below have been moved to user service since contractor data on timesheet is unreliable
		// this.contractorId = successData[this.configService.buyerContractorId];
		// this.ilcSerial = successData[this.configService.ilcSerialNumProp];

		// Only put correction rows into data if timesheet is locked
		// Otherwise leave correction rows as null
		// This way regular rows are only copied over after timesheet is locked

		if (this.isLocked()) {
			// need update contractor ilc as the ilc in the orignal timesheet entry
			// in case contractor ilc setup has been changed from non-ILC to ILC after TS is invoiced
			if (this.dataService.contractorDetails?.[this.configService.contractorILCProp]) {
				this.originalILCFromContractor = this.dataService.contractorDetails[this.configService.contractorILCProp];
				this.dataService.contractorDetails[this.configService.contractorILCProp] =  this.getILCEnabled(successData[this.configService.timeentryProp][0]);
				this.contractorILCUpdated = true; 
			}
			this.dataService.updateTimesheetRows(this.getRows(true), true);
		} else {
			this.contractorILCUpdated = false;
		}
		// the following line with the call to getRows should be after contractor ilc update
		this.dataService.updateTimesheetRows(this.getRows(false), false);
		this.calculateTotal();
	}

	loadTimesheetDocs() {
		const self = this;

		this.dataService.updateTimesheetDocs([]);
		const entityId = this.dataService.timesheetDetails[this.configService.timesheetIDProp];
		const supplierId = this.dataService.timesheetDetails[this.configService.supplierIdProp];
		this.commsService.getExpenseDocs(entityId, supplierId).subscribe((res) => {
			console.log('LOAD TIMESHEET DOCS RES: ', res);
			const successData = self.commsService.getSuccessData(res);
			this.dataService.updateTimesheetDocs(successData);

		}, (err) => {
			self.commsService.handleAPIError('Load Timesheet Docs', err);
		});
	}

	submitTimesheet(timesheet, supcontId, supplierId) {
		const self = this;

		console.log('SUBMIT TIMESHEET', timesheet);

		this.displayService.startLoading();
		this.commsService.sendTimesheet(timesheet).subscribe((res) => {
			this.displayService.endLoading();
			console.log('SUBMIT TIMESHEET RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			self.noteService.displaySuccess('The timesheet status has been successfully changed to ' + this.dataService.convertApproveString(timesheet[self.configService.timeentryProp].status));
			const poNumber = timesheet[self.configService.poNumberProp];
			const contractorId = timesheet[self.configService.contractorIdProp];
			const date = timesheet[self.configService.startDateProp];
			self.loadTimesheet(poNumber, contractorId, supcontId, supplierId, date);
			self.dataService.broadcastNotifications(self.dataObj);

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Submit Timesheet', err);
		});
	}

	submitReasonCode(code) {
		const timesheetId = this.dataService.timesheetDetails[this.configService.timesheetIDProp];
		const poNumber = this.dataService.timesheetDetails[this.configService.poNumberProp];
		const contractorId = this.dataService.timesheetDetails[this.configService.contractorIdProp];
		const date = this.dataService.getTimesheetStart();
		const supcontId = this.dataService.timesheetDetails[this.configService.timesheetSupplierContIdProp];
		const supplierId = this.dataService.timesheetDetails[this.configService.timesheetSupplierIdProp];

		console.log('SUBMIT REASON CODE', timesheetId, code, date, this.dataService.timesheetDetails);

		this.displayService.startLoading();

		this.commsService.sendReasonCode(timesheetId, code['prop']).subscribe((res) => {
			this.displayService.endLoading();
			console.log('SUBMIT REASON CODE RES: ', res);
			this.noteService.displaySuccess('The timesheet status has been successfully changed to SAVE');
			this.loadTimesheet(poNumber, contractorId, supcontId, supplierId, date);
		}, (err) => {
			this.displayService.endLoading();
			this.commsService.handleAPIError('Submit Reason Code', err);
		});
	}

	processTimesheet(approval) {
		this.displayService.startLoading();
		this.commsService.sendTimesheetApproval(approval).subscribe((res) => {
			console.log('PROCESS TIMESHEET RES: ', res);
			// needs a delay since it will take time to get bulk table synched
			setTimeout(() => {
				this.displayService.endLoading();
				this.router.navigateByUrl('timesheets');
				this.noteService.displaySuccess('The timesheet status has been successfully changed to ' + this.dataService.convertApproveString(approval[this.configService.timesheetApprovalProp]));
			}, 2000);
		}, (err) => {
			this.displayService.endLoading();
			this.commsService.handleAPIError('Process Timesheet', err);
		});
	}

	loadQuantityTypes(countrycode = this.configService.countryCodes.US) {
		const self = this;
		this.commsService.getQuantityTypes(countrycode).subscribe((res) => {
			console.log('LOAD QUANTITY RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			this.dataService.updateQuantityTypes(successData);

		}, (err) => {
			self.commsService.handleAPIError('Load Quantity Types', err);
		});
	}

	sendExpenseUpload(formData) {
		const self = this;

		this.displayService.addLoaderId(formData.get('type'));

		this.commsService.uploadExpenseDoc(formData).subscribe((res) => {
			console.log('UPLOAD DOC RES: ', res);

			this.displayService.removeLoaderId(formData.get('type'));

			// SUBSEQUENT ACTIONS
			self.loadTimesheetDocs();

		}, (err) => {
			this.displayService.removeLoaderId(formData.get('type'));
			self.commsService.handleAPIError('Expense Upload', err);
		});
	}

	loadILCReasonCodes() {
		const self = this;

		this.dataService.reasonCodes = [];

		this.commsService.getILCReasonCodes().subscribe((res) => {
			console.log('LOAD REASON CODES RES ', res);

			const successData = self.commsService.getSuccessData(res);
			successData.forEach(function (d, i) {
				const reasonCode = self.dataService.makeReasonAction(d);
				self.dataService.reasonCodes.push(reasonCode);
			});

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Load ILC Reason Codes', err);
		});
	}

	getInvoiceTimesheetHasExpenses(timeentry) {
		let hasExp = false;
		if (timeentry.expenses && timeentry.expenses.total > 0 ||
			timeentry.iscrrreconciled && timeentry.correctionexpenses && timeentry.correctionexpenses.total > 0) {
			hasExp = true;
		}
		return hasExp;
	}

	getTimesheetHasExpenses(timeentry) {
		let hasExp = false;
		if (timeentry.expenses && timeentry.expenses.total > 0 ||
			timeentry.correctionexpenses && timeentry.correctionexpenses.total > 0) {
			hasExp = true;
		}
		return hasExp;
	}

	/**
	 * Rounds the hour entry to a single decimal place
	 */
	roundHour(hour) {
		if (hour.value && !Number.isInteger(hour.value)) {
			const roundedHour = this.roundToDecimal(hour.value, this.dataService.contractorDetails.ilcenabled ? 1 : 2);
			hour.value = 0;
			const delay = setTimeout(function () {
				hour.value = roundedHour;
			}, 1);
		}
		const self = this;
		const delay = setTimeout(function () {
			self.calculateTotal();
		}, 50);
	}

	/**
	 * rounds off to specific amount of decimals, intended to account for floating point precision errors
	 */
	roundToDecimal(value: number, numDecimals: number): number {
		return parseFloat(value.toFixed(numDecimals));
	}

	/**
	 * Validates timesheet hours from the dataService, and a special check for negative values
	 */
	 hourChange(hour: any, index: number, correctRow: boolean, rowIndex: number): void {
		if (hour.value && hour.value > 0
			&& this.dataService.isBankHoliday(correctRow, rowIndex, index)) {
			this.noteService.displayWarning('You are entering hours on a holiday. Please confirm with your manager whether you can enter hours on this day.');
		}
		// handle negative values, set back to 0 if totals equal less than 0 hours
		if (hour.value < 0) {
			if (!correctRow) {
				this.noteService.displayWarning('Negative hours were entered for timesheet row on ' + hour.date);
				hour.value = 0;
			} else {
				if (rowIndex > this.dataService.timesheetRows.length - 1) {
					this.noteService.displayWarning('Negative hours were entered for newly created post processing correction timesheet row on ' + hour.date);
					hour.value = 0;
				} else {
					try {
						console.log('DELTA ROW NEGATIVE', hour, index, correctRow, rowIndex, this.dataService.timesheetRows[rowIndex][index].value, hour.value);

						if (this.dataService.timesheetRows[rowIndex][index].value * -1 > hour.value) {
							this.noteService.displayWarning('Delta hours cannot equal less than zero');
							hour.value = this.dataService.timesheetRows[rowIndex][index].value * -1;
						}
					} catch (e) {}
				}
			}
		}

		// get daily standard hour limit for country of timesheet
		const dailyStandardHourLimit = this.configService.getCountryConfig('maxDailyStandardHours', this.dataService.timesheetDetails.countrycode);
		const dayTotalsByType = this.calculateDayTotalsByType();
		// local function to log warning only if the warning is about the day being edited, to avoid spamming warnings repeatedly
		const logWarningIf = (message, condition) => condition && this.noteService.displayWarning(message);
		// check that daily limits are not being exceeded
		// validation will occur on every day, but warning messages will only be shown for the current day (this way the 'submit' button will be correct)
		let exceedsHourLimit = false;
		dayTotalsByType.forEach(day => {
			if (day.total > 24) {
				logWarningIf(`More than 24 hours are entered for ${day.date}`, day.date === hour.date);
				exceedsHourLimit = true;
			} else if (day.total < 0) {
				logWarningIf(`Negative hours are entered for ${day.date}`, day.date === hour.date);
				exceedsHourLimit = true;
			} else if (day.standard > dailyStandardHourLimit || day.straighttime > dailyStandardHourLimit) {
				logWarningIf(`More than ${dailyStandardHourLimit} standard or straight time hours are entered for ${day.date}`, day.date === hour.date);
				exceedsHourLimit = true;
			}
		});
		this.moreThanDailyAllowedHours = exceedsHourLimit;

		this.hoursAllowed = this.applyHourRules(this.dataService.contractorDetails, dayTotalsByType[index]);

		this.roundHour(hour);
		// when hour changed
		// need make sure special TS row with zero hour configuration still have zero or blank value
		this.checkZeroRows(correctRow);
	}

	calculateDayTotalsByType(): Array<any> {
		// for all rows, both original and corrected, aggregate day totals by type
		const dayTotalsByType = [];
		const numHourDecimals = this.dataService.contractorDetails.ilcenabled ? 1 : 2;
		[...this.dataService.timesheetRows, ...this.dataService.timesheetCorrectRows].forEach(row => {
			row.forEach((cell, cellIndex) => {
				// if day is not in the week array yet, add an empty object
				if (dayTotalsByType[cellIndex] === undefined) {
					dayTotalsByType[cellIndex] = { date: cell.date, total: 0, totalST: 0};
				}
				// for that day of the week, add a property for the type, and initialize it to 0
				if (dayTotalsByType[cellIndex][cell.type] === undefined) {
					dayTotalsByType[cellIndex][cell.type] = 0;
				}
				// add to that day of the week's previous value
				dayTotalsByType[cellIndex][cell.type] += cell.value ? cell.value : 0;
				dayTotalsByType[cellIndex][cell.type] = this.roundToDecimal(dayTotalsByType[cellIndex][cell.type], numHourDecimals);

				dayTotalsByType[cellIndex].total += cell.value ? cell.value : 0;
				dayTotalsByType[cellIndex].total = this.roundToDecimal(dayTotalsByType[cellIndex].total, numHourDecimals);
				if (cell.type === 'standard' || cell.type === 'straighttime') {
					dayTotalsByType[cellIndex].totalST += cell.value ? cell.value : 0;
					dayTotalsByType[cellIndex].totalST = this.roundToDecimal(dayTotalsByType[cellIndex].totalST, numHourDecimals);
				}
			});
		});
		return dayTotalsByType;
	}

	applyHourRules(contractor, totalsByType): boolean {
		const weekDay = this.dataService.getWeekday(totalsByType.date);
		const dailyStandardHourLimit = this.configService.getCountryConfig('maxDailyStandardHours', this.dataService.timesheetDetails.countrycode);

		// collect all rules that apply for overtime for the current country and run them to test if valid OT
		const ruleResults: Array<boolean> = [];
		const warnings: Array<string> = [];
		this.timesheetLocalizationService.getHourRules(this.dataService.timesheetDetails.countrycode).forEach(rule => {
			ruleResults.push(rule(
				{ totalsByType, dailyStandardHourLimit, weekDay, laborType: contractor.labortype, bankHolidays: this.dataService.bankHolidays },
				warnings));
		});
		if (warnings.length > 0) {
			this.noteService.displayWarning(warnings.join('\n'));
		}

		// return true only if ALL rules passed. Otherwise, return false
		return ruleResults.every(result => result === true);
	}

	handlePartialSuccess(res) {
		this.showErrorTimesheets = true;
		this.showSuccessTimesheets = false;
		// expects a 'res' object with an error property.
		// some API responses return the error, but don't have the 'error' property,
		// and so will need to be wrapped in a new object before calling this function
		const error = res.error;

		this.configService.resetTempTab();
		const tempTab = this.configService.tempTab;

		const errorRes = this.commsService.getPartialError(error);
		const errorCount = this.commsService.getSuccessCount(errorRes);
		const errorDataRef = this.errorDataObj + '-' + tempTab.prop + '-' + tempTab.type;
		this.dataService.updatePageData(errorDataRef, tempTab, errorRes);
		this.dataService.updateDataCount(errorDataRef, errorCount);

		const successRes = this.commsService.getPartialSuccess(error);
		const successCount = this.commsService.getSuccessCount(successRes);
		const successDataRef = this.successDataObj + '-' + tempTab.prop + '-' + tempTab.type;
		this.dataService.updatePageData(successDataRef, tempTab, successRes);
		this.dataService.updateDataCount(successDataRef, successCount);

		if (this.dataService.pageData[successDataRef][0].length > 0) {
			this.showSuccessTimesheets = true;
		}
		console.log('PARITAL SUCCESS TIMESHEETS', this.dataService.pageData[errorDataRef][0], this.dataService.pageData[successDataRef][0]);
	}

	closePartialSucessModal(event) {
		this.showErrorTimesheets = false;
		this.showSuccessTimesheets = false;
	}

	/**
	 * Retrieves the non-billable codes from API and sets it to TimesheetService.nonBillableCodes
	 */
	retrieveNonBillableCodes(): void {
		if (this.nonBillableCodes === undefined) {
			this.commsService.getNonBillableCodes().subscribe(result => {
				this.nonBillableCodes = this.commsService.getSuccessData(result).ilccodes;
			});
		}
	}

	getPathToTimesheet(route = false) {
		if (!this.dataService.selectedPO || !this.dataService.userKeys) {
			// to support refreshing page
			this.commsService.getUserKeys().subscribe((res) => {
				const jsonRes = res.detail;
				let poNumber = jsonRes[0][this.configService.poNumberProp];
				let contractorId = jsonRes[0][this.configService.contractorIdProp];
				let supcontId = jsonRes[0][this.configService.supcontIdProp];
				let supplierId = jsonRes[0][this.configService.supplierIdProp];
				this.configService.supplierId = supplierId;
				this.dataService.setUserKeys(jsonRes);
				this.dataService.selectedPO = null;
				// if contractor has more than one POs, need build a jason to map ponumber to its poObject
				if (jsonRes.length > 1) {
					jsonRes.sort((a, b) => {
						if (a.actualenddate < b.actualenddate) {
							return 1;
						}
						if (a.actualenddate > b.actualenddate) {
							return -1;
						}
						return 0;
					});
					this.dataService.setContractorSelectedPO();
					if (this.dataService.selectedPO) {
						const selectedUserKey = this.dataService.userKeys[this.dataService.selectedPO.prop];
						poNumber = selectedUserKey[this.configService.poNumberProp];
						contractorId = selectedUserKey[this.configService.contractorIdProp];
						supcontId = selectedUserKey[this.configService.supcontIdProp];
						supplierId = selectedUserKey[this.configService.supplierIdProp];
						this.configService.supplierId = supplierId;
					}
				} else {
					this.dataService.selectedPO = {
						name: poNumber,
						prop: poNumber
					};
				}
				this.pathToTimesheet = this.createPathToTimesheet(poNumber, contractorId, supcontId, supplierId);
				if (route) {
					this.router.navigateByUrl(this.pathToTimesheet);
				}
			}, (err) => {
				if (err && err.error && err.error.message) {
					this.noteService.displayError(err.error.message);
				}
			});
		} else {
			const selectedUserKey = this.dataService.userKeys[this.dataService.selectedPO.prop];
			const poNumber = selectedUserKey[this.configService.poNumberProp];
			const contractorId = selectedUserKey[this.configService.contractorIdProp];
			const supcontId = selectedUserKey[this.configService.supcontIdProp];
			const supplierId = selectedUserKey[this.configService.supplierIdProp];
			this.pathToTimesheet = this.createPathToTimesheet(poNumber, contractorId, supcontId, supplierId);
			if (route) {
				this.router.navigateByUrl(this.pathToTimesheet);
			}
		}
	}

	createPathToTimesheet(poNumber, contractorId, supcontId, supplierId): string {
		let path = 'timesheet';
		const date = new Date();
		const timesheetDate = this.dataService.formatLocalDate(date);
		if (supcontId) {
			path = path + '/' + poNumber + '/' + contractorId + '/' + supcontId + '/' + supplierId + '/' + timesheetDate;
		} else {
			path = path + '/' + poNumber + '/' + contractorId + '/' + supplierId + '/' + timesheetDate;
		}
		return path;
	}

	/**
	 * Determines whether or not the current timesheet's hours (in the config and data service) are currently editable.
	 */
	allowTimeEdit(isCorrectionRow = false): boolean {
		let allowTimeEdit = false;
		const canEdit = this.configService.canDo(this.configService.getDataObj(this.configService.timesheetDataObj).fields, this.configService.timeentryProp, 'edit');
		const isLocked = this.dataService.getTimeLock();
		const isSaved = this.dataService.getTimesheetStatus() === this.configService.timesheetSaveStatus;
		const isContractor = this.userService.isContractor();
		const hoursLocked = this.dataService.isTimesheetHoursLock();
		const isReconciled = this.dataService.isTimesheetCRR();
		const isRejected = this.dataService.getTimesheetStatusDescription() === this.configService.timesheetRejectedStatus;

		// the normal state of a timesheet page
		if (!isLocked && canEdit && isSaved && !isRejected) {
			allowTimeEdit = true;
		}

		if (isCorrectionRow && canEdit) {
			allowTimeEdit = true;
		}

		if (isContractor && hoursLocked) {
			return false;
		}

		if (hoursLocked && isReconciled) {
			return false;
		}

		const ilcEnabled = this.dataService.contractorDetails.ilcenabled;
		const isReasoned = this.dataService.getTimesheetStatusDescription() === this.configService.timesheetReasonSubmittedStatus;
		if (ilcEnabled && isCorrectionRow && !isReasoned && !hoursLocked) {
			return false;
		}

		if (!ilcEnabled
			&& isCorrectionRow
			&& !isReasoned
			&& this.dataService.getTimesheetInvoiceStatus() === this.configService.timesheetInvoicedStatus) {
			return false;
		}

		return allowTimeEdit;
	}

	/**
	 * Retrieve the list of managed countries from API
	 */
	async retrieveUserManagedCountries(): Promise<void> {
		// clear the saved list of countries
		this.userManagedCountries = null;
		this.userManagedCountrySelection = null;
		const response = await this.commsService.getCountries().toPromise();
		const successData = this.commsService.getSuccessData(response);
		const countryObjects = [];
		Object.keys(successData).forEach(c => countryObjects.push({
			prop: successData[c],
			name: c
		}));
		this.userManagedCountries = countryObjects;
	}

	/**
	 * Set when the user selects which of its managed countries to view
	 */
	selectUserManagedCountry(countryObject): void {
		this.userManagedCountrySelection = countryObject;
	}

	isMultiplePersona(): boolean {
		return this.userService.getAlternatePersona() !== undefined;
	}
}
